import React from 'react';
import CommTableView from '../../views/comm/table';
import { listenWithEmitter, publish } from '../../services/communicator';
import { LIST_QUEUE_STATUS_URL } from '../../services/config';
import { getHeaders } from '../../services/fetch';
import { ProductInstanceCollection, CustomerCollection, LocationCollection } from '../../services/collection';

class CommTableScreen extends React.Component {

  state = {
    items: [],
    appStatus: {}
  };

  componentDidMount() {
    Promise.all([
      this.createListener(),
      this.fetch()
    ])
      .then(() => {
        return publish('app-status-request', '{}')
      })
      .then(() => new Promise(resolve => setTimeout(resolve, 3000)))
      .then(() => {
        return publish('app-status-request', '{}')
      })
      .catch(console.warn)
  }

  async fetch() {
    fetch(
      LIST_QUEUE_STATUS_URL,
      {
        method: 'GET',
        headers: {
          ...getHeaders(),
          Accept: 'application/json'
        }
      }
    )
      .then(response => response.json())
      .then(items => new Promise(resolve => this.setState({
        items: items.map(({ QueueName: name, isYoung: young, isActive: active, ApproximateNumberOfMessages, ...rest }) => ({
          name,
          young,
          active,
          depth: ApproximateNumberOfMessages,
          numberOfEmptyReceives: Object.keys(rest)
            .filter(key => /^NumberOfEmptyReceives\d+$/.test(key))
            .reduce(
              (sum, key) => sum + rest[key],
              0
            )
        }))
      }, resolve)))
      .catch(console.warn);
  }

  async createListener() {
    const emitter = await listenWithEmitter([
      'comm-qstatus',
      'app-status'
    ]);

    if (this.emitterShouldCancel) {
      await emitter.cancel();
      this.connectionShouldCancel = null;
      return null;
    }

    emitter.on('payload', this.onPayload);

    this.cancel = () => emitter.cancel();
  }

  componentWillUnmount() {
    this.emitterShouldCancel = true;
    if (this.cancel) {
      this.cancel();
      this.cancel = null;
    }
  }

  onPayload = payloadString => {
    let payload;

    try {
      payload = JSON.parse(payloadString);
    } catch(e) {

    }

    if (!(payload && payload.systemIdentifier)) {
      this.fetch()
        .catch(console.warn);
    } else if (payload && payload.systemIdentifier) {
      this.setState(({ appStatus }) => ({
        appStatus: {
          ...appStatus,
          [`${payload.systemIdentifier}:${payload.mavenCoordinates.split(':').slice(0, 2).join(':')}`]: payload
        }
      }))
    }
  };

  static getQueueDetailsFromQueueName(name) {
    const match = name.match(/^([A-Z0-9]{4})-([A-Z0-9])-([A-Z0-9-]{36})(?:-([A-Z0-9-]{36}))?$/i);
    return match ? {
      zone: match[1],
      type: match[2],
      identifier: match[3],
      session: match[4]
    } : null;
  }

  getDetailsFromQueueName(name) {
    const { customers, locations, products } = this.props;
    if (!products) {
      return {};
    }
    const details = CommTableScreen.getQueueDetailsFromQueueName(name);
    if (!details) {
      return {};
    }
    const product = products.find(({ uuid }) => uuid === details.identifier);
    if (!(product && product.parentUuid)) {
      return {};
    }
    const productName = product.productId.split(':')[1];
    const location = locations.find(({ uuid }) => uuid === product.parentUuid);
    if (location) {
      return {
        productId: product.productId,
        systemIdentifier: product.systemIdentifier,
        parent: location.name || '',
        product: productName,
        type: details.type
      };
    }
    const customer = customers.find(({ uuid }) => uuid === product.parentUuid);
    return {
      productId: product.productId,
      systemIdentifier: product.systemIdentifier,
      parent: (customer ? customer.name : '') || '',
      product: productName,
      type: details.type
    };
  }

  getVersionDetailsForItem({ systemIdentifier, productId }) {
    return this.state.appStatus[`${systemIdentifier}:${productId}`] || {};
  }

  getItems() {
    const { items } = this.state;
    return items
      .map(
        item => ({
          parent: '',
          product: '',
          ...item,
          ...this.getDetailsFromQueueName(item.name)
        })
      )
      .filter(({ type }) => type === 'p')
      .map(item => ({
        ...item,
        ...this.getVersionDetailsForItem(item)
      }));
  }

  render() {
    return (
      <CommTableView items={this.getItems()} />
    )
  }
}

const mapCustomerProps = ({ loading, list }) => ({ customers: list, customersLoading: loading });
const mapLocationProps = ({ loading, list }) => ({ locations: list, locationsLoading: loading });
const mapProductProps = ({ loading, list }) => ({ products: list, productsLoading: loading });

const customerConnect = CustomerCollection.connect(mapCustomerProps);
const locationConnect = LocationCollection.connect(mapLocationProps);
const productInstanceConnect = ProductInstanceCollection.connect(mapProductProps);

export default customerConnect(
  locationConnect(
    productInstanceConnect(
      CommTableScreen
    )
  )
)



// WEBPACK FOOTER //
// ./src/app/comm/table.js